import { getRemoteConfig, fetchAndActivate, getValue, getString } from 'firebase/remote-config';
import { app } from '../constants/firebaseConfig';

// Initialize Remote Config
const remoteConfig = getRemoteConfig(app);

// Set config settings
remoteConfig.settings = {
    minimumFetchIntervalMillis: 0, // 0 for development (fetch immediately), 3600000 for production (1 hour)
    fetchTimeoutMillis: 60000, // 60 seconds
};

// Set default config values (fallback if fetch fails)
remoteConfig.defaultConfig = {
    math_solver_api_key: 'default-api-key-not-set',
    api_endpoint: 'https://api.example.com/solve',
};

/**
 * Fetch and activate Remote Config values
 * @returns {Promise<boolean>} True if new values were activated
 */
export const fetchRemoteConfig = async () => {
    try {
        console.log('🔄 Fetching Remote Config...');
        const activated = await fetchAndActivate(remoteConfig);

        if (activated) {
            console.log('✅ Remote Config fetched and activated successfully!');
        } else {
            console.log('ℹ️ Remote Config fetched but no new values were activated (using cached values)');
        }

        return activated;
    } catch (error) {
        console.error('❌ Error fetching Remote Config:', error);
        console.log('⚠️ Using default config values');
        return false;
    }
};

/**
 * Get API key from Remote Config
 * @returns {string} API key value
 */
export const getApiKey = () => {
    try {
        const apiKey = getString(remoteConfig, 'math_solver_api_key');
        console.log('🔑 API Key retrieved:', apiKey ? '***' + apiKey.slice(-4) : 'Not set');
        return apiKey;
    } catch (error) {
        console.error('❌ Error getting API key:', error);
        return remoteConfig.defaultConfig.math_solver_api_key;
    }
};

/**
 * Get API endpoint from Remote Config
 * @returns {string} API endpoint URL
 */
export const getApiEndpoint = () => {
    try {
        const endpoint = getString(remoteConfig, 'api_endpoint');
        console.log('🌐 API Endpoint retrieved:', endpoint);
        return endpoint;
    } catch (error) {
        console.error('❌ Error getting API endpoint:', error);
        return remoteConfig.defaultConfig.api_endpoint;
    }
};

/**
 * Get all Remote Config values for testing
 * @returns {Object} All config values
 */
export const getAllConfigValues = () => {
    const apiKey = getApiKey();
    const apiEndpoint = getApiEndpoint();

    const configValues = {
        math_solver_api_key: apiKey,
        api_endpoint: apiEndpoint,
    };

    console.log('📋 All Remote Config Values:', {
        ...configValues,
        math_solver_api_key: apiKey ? '***' + apiKey.slice(-4) : 'Not set'
    });

    return configValues;
};

export default remoteConfig;
